import { cn } from '../lib/utils';
import { CircleNotchIcon } from '@phosphor-icons/react';

function Spinner({ className, ...props }: Readonly<React.ComponentProps<typeof CircleNotchIcon>>) {
  return (
    <CircleNotchIcon
      data-slot="spinner"
      role="status"
      aria-label="Loading"
      className={cn('size-4 animate-spin', className)}
      {...props}
    />
  );
}

export { Spinner };
